module.exports = __webpack_public_path__ + "img/face-neutral.b7f85445.svg";